import { ChangeEventHandler, useCallback, useRef } from "react";
import { ReactComponent as OutlineAttachment } from "assets/svg/outline-attachment.svg";
import IconButton from "components/icon-button";

type Props = {
  onUpload: ChangeEventHandler<HTMLInputElement>;
  className: string;
};

/**
 * renders an upload icon button to the quill toolbar
 */
const Upload = ({ onUpload, className }: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUpload = useCallback(() => {
    if (inputRef.current) {
      // reset input value to identify same file but tried at second time
      inputRef.current.value = "";
      inputRef.current.click();
    }
  }, []);

  return (
    <>
      <IconButton className={className} onClick={handleUpload}>
        <OutlineAttachment />
      </IconButton>
      <input
        type={"file"}
        hidden
        multiple={true}
        ref={inputRef}
        onChange={onUpload}
      />
    </>
  );
};

export default Upload;
